import { useEffect, useState } from "react";
import { usePathname, useSearchParams } from 'next/navigation'
import { useRouter as NextRouter } from 'next/router';
import Image from "next/image";
import dynamic from "next/dynamic";
import { getFilterSetWithSearch, getProductCategorySearch, getProductList, searchKeywordApi } from "../../api/hello";
// import LayoutComponent from "../../../components/layout";
// import ListProduct from "../../../components/ProductList/List";
const DynamicListProduct = dynamic(() => import('../../../components/ProductList/List'));
const DynamicLayoutComponent = dynamic(() => import('../../../components/layout'));
const DynamicDescriptionTab = dynamic(() => import('../../../components/Tab/description_tab'));
// import Filter from "../../../components/Filter";
// import FilterMobile from "../../../components/Filter/filter_mobile";
// import { changeProductListUrl } from "../../../components/ProductList/utils";
import { getLastUrlSegment, handleLinkCanonical, loadServerSideProps } from "../../../utils/utils";
// import HeadComponent from "../../../components/layout/Head";
const DynamicHeadComponent = dynamic(() => import('../../../components/layout/Head'));
import { IBreadcrumbList, IImageObject, INewsArticle, IWebPage } from "../../../components/gSnippet/interface";
import environment from "../../../utils/environment";
import { generateGSnippet } from "../../../components/gSnippet";
import moment from "moment";


export const getServerSideProps = (async (context:any) => {
    if(context?.params?.slug && context?.params?.slug[0] == '[...slug]'){
        return {
            redirect: {
              destination: '/'
            }
          };
    }else{
        let result = { props: {data: null}};
        try {
            // /blog/3
            const { slug } = context.params as { slug: Array<string> }; 
            if(context?.params?.slug && context?.params?.slug[0]){
                let url = "tu-khoa/" + slug?.join("/");
                let resKeyword:any = await loadServerSideProps(url, context.query);//searchKeywordApi(context?.params?.slug[0]);
                if (resKeyword.seo.type < -1) {
                    return {redirect: {
                                destination: '/'
                            }};
                }
                if (resKeyword) {
                    let url = (resKeyword.seo.url && resKeyword.seo.url.trimEnd()) ? resKeyword.seo.url : context.resolvedUrl;
                    resKeyword.seo.url_root = resKeyword.seo.url = url;
                    let number_paging = (context?.params?.slug[2] && context?.params?.slug[2] > 0 ? parseInt(context?.params?.slug[2]) : 1);
                    let linkCanonical = handleLinkCanonical(resKeyword.seo.url_root, number_paging, resKeyword.seo.totalPages);
                    
                    if (number_paging > 1) {
                        resKeyword.seo.url = resKeyword.seo.url + "/page/" + number_paging;
                    }
                    resKeyword.seo = {
                        ...resKeyword.seo,
                        linkCanonical
                    }
                    
                    
                    resKeyword.seo = {
                        ...resKeyword?.seo,
                        title: (resKeyword?.seo?.title ? resKeyword?.seo?.title : "Từ khoá sản phẩm " + resKeyword.keyword + ""),
                        description: (resKeyword?.seo?.description ? resKeyword?.seo?.description : "Bạn đang tìm kiếm sản phẩm " + resKeyword.keyword + ". Bấm vào đây để xem đầy đủ các sản phẩm liên quan: " + resKeyword.keyword + ", đầy đủ và chi tiết")
                    };
                    
                    return { props: {data:{
                                        ...resKeyword
                                    }}
                            }
                }else{
                    return {
                        redirect: {
                          destination: '/'
                        }
                      };
                }
            }
        } catch (error) {
            console.log("error", error);
        };
        return  result;
    }
})

const SearchKeywordPage = ({data}:any) => {
    const routerNext = NextRouter();
    const [openFilter, setOpenFilter] = useState(false);
    const [productGroups, setProductGroups] = useState([]);
    const [search, setSearch] = useState("");
    const [branchs, setBranchs] = useState([]);
    const [_seo, _setSeo] = useState(data?.seo);
    const [linkCanonical, setLinkCanonical] = useState(null);
    const [filterSet, setFilterSet] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [loadingEnd, setLoadingEnd] = useState(true);
    const [titleDescription, setTitleDescription]:any = useState(null);
    const [content, setContent]:any = useState(null);
    const [isMobile, setIsMobile] = useState(false);
    const [products, setProducts]: any = useState({
        page: 1,
        limit: 20,
        totalPages: 0,
        from_date: null,
        to_date: null,
        datas: null,
        filter: {},
        totalElements: 0
    });

    const [gSnippet, setGSnippet] = useState(null);
    const router_path = usePathname();
    const gSnippetLoad = async (tag:any, arr_img: Array<any>) => {
        try{
            let now = moment().toISOString();
            let webPage:IWebPage = {
              name: tag.seo.title,
              description: tag.seo.description,
              dateCreated: "",
              dateModified: "",
              primaryImageOfPage: "",
              keyword: tag.seo.keyword
            }
            let imageObject:IImageObject = {};
            let newsArticle:INewsArticle = {};
            let _breadcrumb:Array<IBreadcrumbList> = [
                {
                    name: "Từ khoá",
                    url: "/tu-khoa"
                }
            ];
            if(tag){
                
                _breadcrumb.push({
                    name: tag.keyword,
                    url: routerNext.asPath
                });

              let image_url = (arr_img && arr_img.length > 0 ? arr_img[0].url_img : "");//environment.baseImageUrl + group_current.image.file_url;
        
              webPage.primaryImageOfPage = image_url;
              webPage.dateCreated = now;
              webPage.dateModified = now;
        
              imageObject = {
                url_img: image_url,
                caption: (arr_img && arr_img.length > 0 ? arr_img[0].name : "")
              }
    
              newsArticle = {
                headline: tag.seo.title,
                arr_image: arr_img.map((x:any) => x.url_img),
                description: tag.seo.description,
                dateCreated: tag?.created_date ? tag.created_date : now,
                dateModified: tag?.modified_date ? tag.modified_date : now,
              }
            }
            let gSnippet = await generateGSnippet(router_path, webPage, imageObject, _breadcrumb, newsArticle);
            setGSnippet(gSnippet);
        }catch(e){
            console.log(e);
        }
        
    }

    async function loadProducts(filter?: any, page?: number, from_date?: any, to_date?: any, limit?: number) {
        try {
            setIsLoading(true);
            setLoadingEnd(true);
            limit = limit ?? products.limit;
            filter = filter ?? products.filter;

            page = page ?? products.page;
            from_date = from_date ?? "";
            to_date = to_date ?? "";
            //setIsLoading(true);
            //item = item.replace("%20", " ");
            let key:any = localStorage.getItem("search");
            let search_temp:any = getLastUrlSegment(window?.location?.href.toString());
            let resKeyword = await searchKeywordApi(search_temp);
            //(data ? {...data} : await searchKeywordApi(search_temp))
            if (resKeyword) {
                
                // resKeyword.seo = {
                //     ...resKeyword?.seo,
                //     title: (resKeyword?.seo?.title ? resKeyword?.seo?.title : "Từ khoá sản phẩm " + resKeyword.keyword + ""),
                //     description: (resKeyword?.seo?.description ? resKeyword?.seo?.description : "Bạn đang tìm kiếm sản phẩm " + resKeyword.keyword + ". Bấm vào đây để xem đầy đủ các sản phẩm liên quan: " + resKeyword.keyword + ", đầy đủ và chi tiết")
                // };
                
                if(page && page > 1){
                    resKeyword.description = null;
                }
                await setTitleDescription(
                    {
                        title: resKeyword.title,
                        description: resKeyword.description
                    }
                );
                // // key = resKeyword.keyword;
                await setSearch(resKeyword.keyword);
                let res:any = null;
                if(data.products && data.products.results && data.products.results.length > 0){
                    res = data.products
                }else{
                    res = await getProductList(`limit=${limit}&page=${page}&from_date=${from_date}&to_date=${to_date}`, {
                        keyword_code: resKeyword.code,
                        ...filter
                    });
                }
                if (res && res.results) {
                    if(!data.seo.url_next && !data.seo.url_prev){
                        let seo_LinkCanonical:any = handleLinkCanonical(data.seo.url_root, (page ? page : 1), res.totalPages);
                        // console.log("seo_LinkCanonical: ", seo_LinkCanonical);
                        await setLinkCanonical(seo_LinkCanonical);
                    }
                    
                    await setProducts({
                        page: page,
                        from_date: from_date,
                        to_date: to_date,
                        limit: limit,
                        totalPages: res.totalPages,
                        filter: filter,
                        datas: res.results,
                        totalElements: res.totalElements
                    });
                    setTimeout(async function(){
                        await setContent(
                            resKeyword.content
                        );
                    }, 400);
                    setIsLoading(false);
                    setTimeout(function(){
                        setLoadingEnd(false);
                    }, (400));
                    let arr_img:any = [];
                    res.results.map((x:any, ix:number)=> {
                        if(x && x.file){
                            arr_img.push({
                                name: x.name,
                                url_img: environment?.baseImageUrl + x.file.image_url
                            });
                            if(ix==0){
                                resKeyword.seo={
                                    ...resKeyword.seo,
                                    file: {
                                        file_url: environment.baseImageUrl + x.file.image_url,
                                        file_type: x.file.image_type,
                                        alt: x.file.alt,
                                    },
                                }
                            }
                        }
                        
                    });
                    // await _setSeo(resKeyword.seo);
                    await gSnippetLoad(resKeyword, arr_img);
                }
            }
            
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            setLoadingEnd(false);
        }
    }

    async function onChangePage(page: number) {
        // console.log("onChangePage")
        await loadProducts(products.filter, page, products.from_date, products.to_date);
    }

    async function loadFilter() {
        try {
            let res: any = await getProductCategorySearch(search) ?? null;
            if (res) {
                setProductGroups(res?.results ?? []);
            }
        } catch (error) {
        }
    }

    async function loadFilterSet() {
        try {
            let res: any = await getFilterSetWithSearch(search) ?? null;
            if (res) {
                setFilterSet(res?.results ?? []);
            }
        } catch (error) {

        }
    }

    function onSearchFilter(filter: any, from_date: any, to_date: any) {
        filter.group_id = filter.group_id === 0 ? products.filter?.group_id : (filter.group_id ?? products.filter?.group_id);
        loadProducts(filter, products.page, from_date, to_date)
    }

    function onOpenFilter() {
        setOpenFilter(!openFilter)
    }

    async function onScrollPaging() {
        let limit = products.limit + 10;
        if (limit < products.totalElements) {
            await loadProducts(products.filter, 1, products.from_date, products.to_date, limit);
        } else {
            limit = products.totalElements;
            await loadProducts(products.filter, 1, products.from_date, products.to_date, limit);
        }

    }
    
    // useEffect(() => {
    //     loadProducts(window.location.origin);
    // }, [search])

    // useEffect(() => {
    //     if(content){
    //         let search_title = document.getElementById("search_title");
    //         if (search_title) {
    //             search_title.innerHTML = content.title ?? " ";
    //         }
    //         let search_content = document.getElementById("search_content");
    //         if (search_content) {
    //             search_content.innerHTML = content.content ?? " ";
    //         }
    //         let search_description = document.getElementById("search_description");
    //         if (search_description) {
    //             search_description.innerHTML = content.description ?? " ";
    //         }
    //     }
        
    // }, [content]);

    useEffect(() => {
        if (routerNext.asPath.indexOf('[...slug]') <= 0) {
            let page: any = 1;
            if (routerNext.asPath.indexOf("page") > -1) {
                page = Number(routerNext.asPath.slice(routerNext.asPath.length - 1, routerNext.asPath.length));
                if (!Number(page)) {
                    page = 1;
                }
            }
            onChangePage(page);
        }

    }, [routerNext.asPath]);

    useEffect(() => {
        setIsMobile(window.innerWidth < 976);
    }, []);

    useEffect(() => {
        document.querySelectorAll('.e-rte-image').forEach(($el:any) => {
            $el.style.maxHeight = ''; 
        });
    }, [titleDescription]);

    return <>
        {/* <Head>
            <title>{seo?.seo?.title ?? ""}</title>
            <meta name="description" content={seo?.seo?.description ?? ""} />
            <meta key={'keywords'} name={'keywords'} content={seo?.seo?.keyword ? seo?.seo?.keyword?.map((e: any) => e.keyword)?.join(",") : ""} />
            <link rel="icon" href="/asset/icon/favicon.ico" />
            <link rel="canonical" href={url} />
            <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        </Head> */}
        <DynamicHeadComponent gSnippet={gSnippet} seo={_seo} linkCanonical={linkCanonical}/>
        <DynamicLayoutComponent className='' isLoading={isLoading} loadingEnd={loadingEnd}>
            {/* Black Menu */}

            <div className="products_head items-center relative">
                <div className="opacity_bg">

                </div>
                {/* DESKTOP */}
                {
                    !isMobile && 
                    <div id="horizontal-scroll-wrapper" className="horizontal-scroll-wrapper justify-center hide_scrollbar hidden lg:flex">
                        <div
                            className={"itemInActive"}
                        >
                            <span>{"Từ khoá"}</span>
                        </div>
                        <div
                            className={"itemActive normal-case cursor-pointer"}
                        >
                            <span>{search}</span>
                        </div>
                    </div>
                }
                {/* MOBILE */}
                {
                    isMobile && <div className="wrapperSwitch m-0 overflow-x-auto hide_scrollbar lg:hidden flex">
                    <div style={{width: "90px"}} className="border-r border-gray-400 h-full shadow itemInActive flex items-center">
                        <span>{"Từ khoá"}</span>
                    </div>
                    <div className="itemActive">
                        <span>{search}</span>
                    </div>
                </div>
                }
                
            </div>
            <div className="body_padding">
                {titleDescription && <div className='wrap-product-detail mt-product-detail'>
                    {/* <div id='form_in_modal_group_content' className='bg-white mx-auto richTextEditor e-control e-richtexteditor e-lib e-rte-toolbar-enabled'>
                        <div className='e-rte-content h-auto mt-0' id="form_in_modal_group_contentrte_view">
                            {titleDescription?.title &&<div id="search_title" className="w-full p-4 overflow-y-auto rounded-[8px]" dangerouslySetInnerHTML={{__html: titleDescription.title}}>
                                </div>
                            }
                            {titleDescription?.description && <div id="search_description" className="e-content e-lib e-keyboard"
                                                            dangerouslySetInnerHTML={{__html: titleDescription.description}}>
                            </div>
                            }
                        </div>
                    </div> */}
                    <DynamicDescriptionTab content={titleDescription.title ?? ""} key={"contentTab"} hidden={false}/>
                    {
                        titleDescription.description && <DynamicDescriptionTab content={titleDescription.description} key={"descriptionTab"} hidden={false}/>
                    }
                </div>}
                {products?.datas?.length == 0 ? <div className="mb-[100px] flex w-full justify-center">
                    <Image
                        className="relative"
                        src={"/asset/image/search_not_found.webp"}
                        alt="not_found_search"
                        fill
                        objectFit='cover'
                    />
                </div> : products?.datas?.length > 0  ? <DynamicListProduct
                    isLoading={false}
                    className=""
                    onChangePage={onChangePage}
                    products={products}
                    branchs={branchs} onIncreaseLimit={null} /> : <></>}
                
                {content && <div className='wrap-product-detail'>
                    {/* <div id='form_in_modal_group_content' className='bg-white mx-auto richTextEditor e-control e-richtexteditor e-lib e-rte-toolbar-enabled'>
                        <div className='e-rte-content h-auto mt-0' id="form_in_modal_group_contentrte_view">
                            <div id="search_content" className="e-content e-lib e-keyboard" dangerouslySetInnerHTML={{__html: content}}>
                            </div>
                        </div>
                    </div> */}
                    <DynamicDescriptionTab content={content ?? ""} key={"contentTab"} hidden={false}/>
                </div>}
            </div>
            {/* <div onClick={() => onOpenFilter()} className="filter_button">
                <div className="red-dot"></div>
                <div className="content">Lọc sản phẩm</div>
                <Image
                    loading="lazy"
                    src="/asset/icon/ico_two_tone.svg"
                    alt="filter"
                    width={24}
                    height={24}
                />
            </div> */}
            {/* {openFilter && <Filter
                onOpenFilter={onOpenFilter}
                onSearch={onSearchFilter}
                productGroupData={productGroups}
                filterSetData={filterSet}
                activeTypeData={changeProductListUrl(routerNext.asPath)}
            />}
            {
                <FilterMobile
                    openFilter={openFilter}
                    onOpenFilter={onOpenFilter}
                    onSearch={onSearchFilter}
                    productGroupData={productGroups}
                    filterSetData={filterSet}
                    activeTypeData={changeProductListUrl(routerNext.asPath)}
                />
            } */}
        </DynamicLayoutComponent>
    </>;
}

// export async function getServerSideProps(context: any) {
//     console.log("test");

//     return {
//         props: {
//             item: context.query?.slug[0] ?? ""
//         }
//     };
// }

export default SearchKeywordPage;